import React from "react";
import {withTranslation} from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import { getCurrencyIcons, HALF_OPTION } from '../../../utils/enums';
import {isRTL} from "../../../services/userModel.js";
import IconButton from "../IconButton/index.js";

const OrderMenuOption = ({ t, key, option, order }) => {
    const suboptions = (option && option.suboptions) || [];

    return (
        <div key={key} className={classNames("orderMenuOption")}>
            <div className={classNames("title")}>{(option && option.name) || t("pending-orders.PENDING_ORDER_EMPTY_OPTION_LABEL")}:&nbsp;</div>
                <div className={classNames("suboptions")}>
                    {suboptions.map((suboption, index)=> (
                        <div key={`suboption-${index}`} className={classNames("suboption")}>
                            <span>
                                &nbsp;
                                {suboption.with_half_option && !suboption.pizza_option && `${HALF_OPTION[suboption.half_option]} `}
                                {(suboption && suboption.name) || t("pending-orders.PENDING_ORDER_EMPTY_OPTION_LABEL")}
                            </span>
                            <span className={classNames("currencyPending")}>
                                {suboption.quantity > 1 && (<span className={classNames("quantity")}>&nbsp;x{suboption.quantity}</span>)}
                                {suboption.full_price > 0 && <span className={classNames("currency")}>
                                    {isRTL() ? <span className={classNames('currencyRtl')}>
                                            <span>+{suboption.full_price}</span>
                                            <span>{(order && getCurrencyIcons(order.currency))}</span>
                                        </span> :
                                        <>&nbsp;+{suboption.full_price}{(order && getCurrencyIcons(order.currency))}</>}
                                </span>}
                            </span>
                            {suboption.pizza_option && suboption.with_half_option && (
                                <IconButton isIcon iconName={'halfOption_' + (suboption.half_option ?? suboption.halfOption)}/>
                            )}
                        </div>
                    ))}
                </div>
        </div>
    )
}

export default withTranslation()(OrderMenuOption);
